<template>
  <main>
    <div class="tab-header">
      <div class="container-fluid">
        <div class="row mb-20">
          <div class="col-2">
            <h4>公式維護</h4>
          </div>
          <div class="col-10 text-right">
            <a
              class="btn btn-default top-button"
              @click="$router.push({ name: 'CoverageFormulaValidation' })"
              >公式試算
            </a>
            <a
              class="btn btn-default top-button"
              @click="$router.push({ name: 'ProductMenuPage', params:{ isback: true } })"
              >回商品維護
            </a>
          </div>
        </div>
        <div class="text-right">
          <span>
            公  司: 
            <span class="font-weight-bold">{{productData.company.COMPSNM}}</span>  
            <span class="font-weight-bold">{{" " + getProductTypeName(productData.productType)}}</span>
            險種種類:
            <span class="font-weight-bold">{{getContractTypeName(productData.contractType)}}</span>
            商品名稱:
            <span class="font-weight-bold">{{productData.insuranceName}}</span>
            <span class="font-weight-bold" v-if="productData.insuranceCode">({{productData.insuranceCode}})</span>
          </span>
        </div>
        <ul class="nav nav-pills" role="tablist">
          <li class="nav-item" @click="$router.push({ name: 'CoverageFormulaSummary' })">
            <a
              class="nav-link show"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'CoverageFormulaSummary' }"
              >	保障摘要</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'ThisYearInsuranceAmount' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'ThisYearInsuranceAmount' }"
              >當年度保額</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'DeathAndDisabilityBenefit' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'DeathAndDisabilityBenefit' }"
              >身故及全殘保險金</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'LivingBenefits' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'LivingBenefits' }"
              >生存保險金</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'MaturityBenefit' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'MaturityBenefit' }"
              >滿期保險金</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'GoodWishBenefit' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'GoodWishBenefit' }"
              >祝壽金</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'PermanentDisabilityBenefit' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'PermanentDisabilityBenefit' }"
              >傷殘保險金</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'DreadDiseaseBenefit' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'DreadDiseaseBenefit' }"
              >重大疾病</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'LongTermCareBenefit' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'LongTermCareBenefit' }"
              >長期照顧</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'CancerBenefit' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'CancerBenefit' }"
              >癌症保險金</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'DiseaseAndAccidentalBenefit' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'DiseaseAndAccidentalBenefit' }"
              >疾病/意外醫療保險金</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'AccidentalMedical' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'AccidentalMedical' }"
              >意外保障</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'PremiumWaiver' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'PremiumWaiver' }"
              >豁免保障</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'WomenBenefit' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'WomenBenefit' }"
              >婦女險</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'OthersSecurity' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'OthersSecurity' }"
              >其他保障</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'MedicalExpenseLimit' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'MedicalExpenseLimit' }"
              >醫療限額</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'SettingNotes' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="coverageFormulaNavLink"
              :class="{ active: $route.name === 'SettingNotes' }"
              >設定註解</a
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <div class="container-fluid">
        <router-view></router-view>
      </div>
    </div>

  </main>
</template>

<script>
import { mapGetters } from "vuex";
import ThisMixin from "./InsuranceProduct";

export default {
  name: "CoverageFormula",
  mixins: [ThisMixin],
  computed: {
    ...mapGetters(["UserItems"]),
  },
  data() {
    return {
      coverageItemAddModalOpen: false,
      coverageKindAddModalOpen: false,
      productData: JSON.parse(localStorage.productData),
    };
  },
  mounted() {
    this.$router.push({ name: 'CoverageFormulaSummary' });
  },
  methods: {
    getProductTypeName(productType) {
      return this.options.productType.filter((x) => x.value == productType)[0]
        .name;
    },
    getContractTypeName(contractType) {
      return this.options.contractType.filter((x) => x.value == contractType)[0]
        .name;
    },
  },
};
</script>
<style>
* {
  user-select: text;
}
.font-20 {
  font-size: 20px;
}
.font-16 {
  font-size: 16px;
}
.w-120 {
  width: 120px;
}
.mb-20 {
  margin-bottom: 20px;
}
</style>

<style scoped>
  .container-fluid {
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 40px;
}
.nav-pills .nav-link {
  background: #F5F5F5;
  border: 1px solid #C2C4C7;
  margin: 2px 2px;
  border-radius: 8px 8px;
}

.nav-pills .nav-link:hover {
  background: #FFF;
}

.nav-pills .active{
    color: #00AA42;
    font-weight: 800;
    border: 2px solid #00AA42;
    background: #FFF;
}

.top-button {
  height: 30px;
  padding-top: 0px;
  line-height: 28px;
}

.nav-item {
  cursor: pointer;
}
</style>